import { CardItemModel } from '../../types/flo-experience'
import { captureSessionData } from '../../utils/segmentAnalytics'
import Search from '../search'

const FAVORITES_PAGINATION_LIMIT = 24

export default class AddFavoritesEntitySearch extends Search {
  async _onMounted() {
    super._onMounted()
    this._isRoot = false
  }

  _onUrlParams({ url }: { url: string }): void {
    const [apiResource, searchParams] = url.split('?')
    const urlSearchParams = new URLSearchParams(searchParams)
    urlSearchParams.append('limit', FAVORITES_PAGINATION_LIMIT.toString())
    const correctedEntitySearchUrl = `${apiResource}?${urlSearchParams.toString()}`

    super._onUrlParams({ url: correctedEntitySearchUrl })
  }

  async $onApiCall(
    response: boolean | ErrorType,
    _cardItemModel: CardItemModel,
    rowIndex: number,
    cardIndex: number,
  ) {
    if (typeof response === 'boolean' && response === true) {
      void captureSessionData()
      const prevLayoutConfig = this.tvSearchLayout.lastLayoutConfig
      const { lastSearchUrl, lastQuery, pageNumber, paginationUrl } = prevLayoutConfig
      const [apiResource, searchParams] = lastSearchUrl.split('?')
      const urlSearchParams = new URLSearchParams(searchParams)

      urlSearchParams.set('limit', FAVORITES_PAGINATION_LIMIT.toString())
      if (lastQuery) {
        urlSearchParams.set('query', lastQuery)
      }

      if (pageNumber && paginationUrl) {
        // We use the existing paginationUrl and simply update the offset query param, as we just need to fecth the partial
        // for the current page the user added or removed the favorite from. We can't rely on the true last paginationUrl
        // as it might not reflect the range of cards the user really actioned this $onApiCall
        const [paginationApiResource, paginationSearchParams] = paginationUrl.split('?')
        const paginationUrlSearchParams = new URLSearchParams(paginationSearchParams)
        const pageSize =
          parseInt(paginationUrlSearchParams.get('limit'), 0) ?? FAVORITES_PAGINATION_LIMIT
        const offset = pageNumber * pageSize

        paginationUrlSearchParams.set('offset', offset.toString())
        prevLayoutConfig.paginationUrl = `${paginationApiResource}?${paginationUrlSearchParams.toString()}`
      }

      if (Number.isInteger(rowIndex)) {
        prevLayoutConfig.lastRowIndex = rowIndex
      }

      if (Number.isInteger(cardIndex)) {
        prevLayoutConfig.lastCardIndex = cardIndex
      }

      prevLayoutConfig.lastSearchUrl = `${apiResource}?${urlSearchParams.toString()}`
      prevLayoutConfig.refreshChildren = true
      this.layoutConfig = prevLayoutConfig

      await this.getInitialSearchData()
      this._refocus()
    } else {
      console.error('There was an error updating favorites. Reason: ', response)
    }
  }
}
